import { render, staticRenderFns } from "./StagePriceInfo.vue?vue&type=template&id=671d7f8a&scoped=true&"
import script from "./StagePriceInfo.vue?vue&type=script&lang=js&"
export * from "./StagePriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./StagePriceInfo.vue?vue&type=style&index=0&id=671d7f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d7f8a",
  null
  
)

export default component.exports